import { IntlShape } from "react-intl";

export const getTranslation = (intl: IntlShape, id: string, params?: any) => {
  return intl.formatMessage({ id: id }, params);
};
